import { Matrix4, Plane, Quaternion, Raycaster, Vector3 } from 'three'

const _plane = new Plane()
const _hit = new Vector3()
const _origin = new Vector3()
const _quat = new Quaternion()
const _scale = new Vector3()

export type FloorDragSession = {
  planeY: number
  grabOffset: Vector3
  startMatrix: Matrix4
}

export function createFloorDragSession(
  pointerRay: Raycaster,
  itemMatrix: Matrix4,
): FloorDragSession | null {
  itemMatrix.decompose(_origin, _quat, _scale)
  _plane.set(new Vector3(0, 1, 0), -_origin.y)
  if (!pointerRay.ray.intersectPlane(_plane, _hit)) return null
  const grabOffset = _hit.clone().sub(_origin)
  grabOffset.y = 0
  return {
    planeY: _origin.y,
    grabOffset,
    startMatrix: itemMatrix.clone(),
  }
}

/** Posición en suelo siguiendo el cursor (sin saltos en Y). */
export function floorDragMatrixFromPointer(
  pointerRay: Raycaster,
  session: FloorDragSession,
  itemMatrix: Matrix4,
  target: Matrix4,
): boolean {
  _plane.set(new Vector3(0, 1, 0), -session.planeY)
  if (!pointerRay.ray.intersectPlane(_plane, _hit)) return false

  itemMatrix.decompose(_origin, _quat, _scale)
  const nextPos = _hit.clone().sub(session.grabOffset)
  nextPos.y = session.planeY
  target.compose(nextPos, _quat, _scale)
  return true
}
